import { Box, ListItem } from '@mui/material';

import GreenCircledCheckMark from '~/assets/icons/new/greenCircledCheckMark.svg?react';
import TranslatedLabel from '~/common/components/TranslatedLabel/TranslatedLabel';
import SeeAllButton from '~/routes/notifications/components/SeeAllButton';

import { useStyles } from '../NotificationCard.styles';

type NoNotificationCardProps = {
  context: 'popover' | 'page';
};

function NoNotificationCard({ context }: NoNotificationCardProps) {
  const { classes } = useStyles();

  return (
    <ListItem
      className={
        classes[
          'rt--notifications--cmp--list--list-item--notification-item--no-notifications'
        ]
      }
      sx={{ width: context === 'page' ? '100%' : '480px' }}
    >
      <Box marginBottom="16px">
        <GreenCircledCheckMark />
      </Box>
      <TranslatedLabel
        dataTestId="no-notification-card-text"
        className="no-notifications-text"
        typographyVariant="body_medium"
        translationKey={
          context === 'popover'
            ? 'settings:notifications.messages.noUnread'
            : 'settings:notifications.messages.noneAtAll'
        }
      />
      {context === 'popover' && <SeeAllButton variant="tertiary" />}
    </ListItem>
  );
}

export default NoNotificationCard;
